<template>
  <div class="skeleton content">
    <div class="skeleton__animate--white content__header"></div>
    <div class="content__row">
      <div class="skeleton__animate--white content__tile"></div>
      <div class="content__text">
        <h4 class="skeleton__title skeleton__animate--white"></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="content__btn-wrapper">
        <figure
          class="skeleton__animate--white skeleton__btn content__btn"
        ></figure>
      </div>
    </div>
    <div class="content__row">
      <div class="skeleton__animate--white content__tile"></div>
      <div class="content__text">
        <h4 class="skeleton__title skeleton__animate--white"></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="content__btn-wrapper">
        <figure
          class="skeleton__animate--white skeleton__btn content__btn"
        ></figure>
      </div>
    </div>
    <div class="content__row">
      <div class="skeleton__animate--white content__tile"></div>
      <div class="content__text">
        <h4 class="skeleton__title skeleton__animate--white"></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="content__btn-wrapper">
        <figure
          class="skeleton__animate--white skeleton__btn content__btn"
        ></figure>
      </div>
    </div>
    <div class="content__row">
      <div class="skeleton__animate--white content__tile"></div>
      <div class="content__text">
        <h4 class="skeleton__title skeleton__animate--white"></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="content__btn-wrapper">
        <figure
          class="skeleton__animate--white skeleton__btn content__btn"
        ></figure>
      </div>
    </div>
    <div class="content__row">
      <div class="skeleton__animate--white content__tile"></div>
      <div class="content__text">
        <h4 class="skeleton__title skeleton__animate--white"></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="content__btn-wrapper">
        <figure
          class="skeleton__animate--white skeleton__btn content__btn"
        ></figure>
      </div>
    </div>
    <div class="content__row">
      <div class="skeleton__animate--white content__tile"></div>
      <div class="content__text">
        <h4 class="skeleton__title skeleton__animate--white"></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="content__btn-wrapper">
        <figure
          class="skeleton__animate--white skeleton__btn content__btn"
        ></figure>
      </div>
    </div>
    <div class="content__row">
      <div class="skeleton__animate--white content__tile"></div>
      <div class="content__text">
        <h4 class="skeleton__title skeleton__animate--white"></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="content__btn-wrapper">
        <figure
          class="skeleton__animate--white skeleton__btn content__btn"
        ></figure>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PathContentSkel',
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 15px 10px 15px;
  margin: 20px 0;
  @include tablet {
    padding: 20px 75px;
    margin: 0 0 0 35px;
  }
  &__header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    margin: 0 0 50px 0;
  }
  &__row {
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 50px 0;
    @include tablet {
      flex-wrap: nowrap;
    }
  }
  &__tile {
    margin: 0 auto 0 0;
    height: 120px;
    width: 200px;
    @include tablet {
      margin: 0 0 0 50px;
    }
  }
  &__text {
    padding: 0 10px;
    margin: 0 auto 0 0;
  }
  &__btn-wrapper {
    margin: auto 0 0 auto;
  }
  &__btn {
    width: 150px;
  }
}
</style>
